{
    "DisplayAsLabel": "Valutaweergave-indeling",
    "ColorTileBackgroundLabel": "Tegel Kleur:",
    "ColorTileTextLabel": "Tekstkleur:",
    "FitImageLabel": "Pas afbeelding",
    "DisplayTitleLabel": "Titeltekstgebied weergeven",
    "AutoValuePlaceholder": "[Auto]",
    "ImageUrlPlaceholder": "https:\/\/example.com\/image.png",
    "ImageUrlLabel": "Afbeelding URL:",
    "Black": "zwart",
    "White": "Wit",
    "Blanc": "Blanco",
    "Smoke": "Rook",
    "Grey": "Grijs",
    "Battleship": "Slagschip",
    "Aqua": "Aqua",
    "Blue": "Blauw",
    "Waters": "wateren",
    "Sky": "Lucht",
    "Akixi": "Akixi",
    "Midnight": "Middernacht",
    "Pistachio": "Pistache",
    "Green": "Groente",
    "Forest": "Woud",
    "Salmon": "Zalm",
    "Red": "Rood",
    "Rosita": "Rosita",
    "Peach": "Perzik",
    "Orange": "Oranje",
    "Clementine": "Clementine",
    "Amarelo": "Amarello",
    "Yellow": "Geel",
    "Sunflower": "Zonnebloem",
    "Lilac": "Lila",
    "Purple": "Purper",
    "Regal": "Vorstelijk",
    "Blush": "Blozen",
    "Pink": "Roze",
    "Fuchsia": "Fuchsia",
    "Caribbean": "Caraïben",
    "Teal": "Wintertaling",
    "Peacock": "Pauw",
    "SimpleTextValue": "[Eenvoudige tekstwaarde]",
    "ProgressRing": "Voortgangsring",
    "GradatedDial": "Gegradeerde wijzerplaat",
    "GlideSlope": "Glijhelling",
    "Bullseye": "In de roos",
    "BarGauge": "Staafmeter",
    "ConeGauge": "Kegelmeter",
    "DashboardSpeedometerBlack": "Dashboard snelheidsmeter (zwart)",
    "DashboardSpeedometerAmber": "Dashboard snelheidsmeter (oranje)",
    "DashboardTemperatureGauge": "Dashboard temperatuurmeter",
    "DashboardFuelGauge": "Dashboard brandstofmeter",
    "DashboardPowerGauge": "Dashboard Vermogensmeter",
    "DashboardColourGauge": "Dashboard Kleurmeter",
    "GaugeFaceLabel": "Omgekeerd meetvlak:",
    "GaugeFaceDirection": "Omgekeerde meetrichting:",
    "MaxScaleLabel": "Maximale schaal:",
    "DisplayPreviewCaption": "Preview",
    "DisplaySettings_SectionHeader": "Aangepaste instellingen",
    "NAME": "DisplaySettings",
    "VividSky": "Levendige hemel",
    "ElectricIndigo": "Indigo elektrisch",
    "OxfordBlue": "Blauw Oxford",
    "Aquamarine": "Aquamarijn"
}